import { forwardRef } from 'react';

const StartMenu = forwardRef(function StartMenu({ apps, activeApp, onOpenApp }, ref) {
  return (
    <section className="start-menu panel-glass" ref={ref} aria-label="Start menu">
      <div className="start-menu-header">
        <div>
          <p className="eyebrow">All Apps</p>
          <h2>{activeApp.windowTitle}</h2>
        </div>
        <p className="start-menu-copy">Open an app to explore my projects, skills, and background.</p>
      </div>

      <div className="start-menu-list">
        {apps.map((app) => (
          <button
            key={app.id}
            type="button"
            className="start-item"
            onClick={() => onOpenApp(app.id)}
            aria-label={`Open ${app.windowTitle}`}
          >
            {app.icon ? (
              <img src={app.icon} alt="" className="start-item-icon" />
            ) : (
              <span className={`start-item-icon accent-${app.accent}`} />
            )}
            <span>
              <strong>{app.menuLabel}</strong>
              <small>{app.category}</small>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
});

export default StartMenu;
